var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rbv-ng-invitations-handler"},[(_vm.activeModuleComponent)?_c(_vm.activeModuleComponent,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }